import React, { useEffect, useState } from "react";
import {
  Box,
  InputLabel,
  FormControl,
  Grid,
  Paper,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useLogger } from "../../../../contexts/LoggerContext";
import { useSchemes } from "../../../../contexts/SchemesContext";
import { DefensivePlaySelection } from "../../../../types/LogTypes";

export const DefensePlaySelection = () => {
  const { setCurrentPlayCall, clearSelections } = useLogger();
  const { defensivePersonnel, fronts, stunts, coverages } = useSchemes();
  const [selectedPersonnel, setSelectedPersonnel] = useState<number | null>(
    null
  );
  const [selectedFront, setSelectedFront] = useState<number | null>(null);
  const [selectedStunt, setSelectedStunt] = useState<number | null>(null);
  const [selectedCoverage, setSelectedCoverage] = useState<number | null>(null);

  useEffect(() => {
    const playCall: DefensivePlaySelection = {
      personnel_group_id: selectedPersonnel,
      front_id: selectedFront,
      stunt_id: selectedStunt,
      coverage_id: selectedCoverage,
    };
    setCurrentPlayCall(playCall);
  }, [
    selectedPersonnel,
    selectedFront,
    selectedStunt,
    selectedCoverage,
    setCurrentPlayCall,
  ]);

  useEffect(() => {
    if (clearSelections) {
      setSelectedPersonnel(null);
      setSelectedFront(null);
      setSelectedStunt(null);
      setSelectedCoverage(null);
    }
  }, [clearSelections]);

  const handlePersonnelChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedPersonnel(event.target.value as number);
  };

  const handleFrontChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedFront(event.target.value as number);
  };

  const handleStuntChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedStunt(event.target.value as number);
  };

  const handleCoverageChange = (event: SelectChangeEvent<number | "">) => {
    setSelectedCoverage(event.target.value as number);
  };

  return (
    <Paper elevation={3} sx={{ p: 1 }}>
      <Box>
        <Grid container spacing={3}>
          {/* Personnel Group Selection */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200 }}>
              <InputLabel id="personnel-group-label">
                Personnel Group
              </InputLabel>
              <Select
                labelId="personnel-group-label"
                id="personnel-group"
                value={selectedPersonnel || ""}
                label="Personnel Group"
                onChange={handlePersonnelChange}
              >
                {defensivePersonnel.map((group) => (
                  <MenuItem key={group.id} value={group.id}>
                    {group.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Front Selection */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200 }}>
              <InputLabel id="front-label">Front</InputLabel>
              <Select
                labelId="front-label"
                id="front"
                value={selectedFront || ""}
                label="Front"
                onChange={handleFrontChange}
              >
                {fronts.map((front) => (
                  <MenuItem key={front.id} value={front.id}>
                    {front.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Stunt Selection */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200 }}>
              <InputLabel id="stunt-label">Stunt</InputLabel>
              <Select
                labelId="stunt-label"
                id="stunt"
                value={selectedStunt || ""}
                label="Stunt"
                onChange={handleStuntChange}
              >
                {stunts.map((stunt) => (
                  <MenuItem key={stunt.id} value={stunt.id}>
                    {stunt.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Coverage Selection */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth sx={{ mb: 1, minWidth: 200 }}>
              <InputLabel id="coverage-label">Coverage</InputLabel>
              <Select
                labelId="coverage-label"
                id="coverage"
                value={selectedCoverage || ""}
                label="Coverage"
                onChange={handleCoverageChange}
              >
                {coverages.map((coverage) => (
                  <MenuItem key={coverage.id} value={coverage.id}>
                    {coverage.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
